var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonnaliseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.431,
    height: 30,
    viewBox: "0 0 37.431 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.86 -41.571)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.607,59.928c-.585-.153-.152-.587.3-.976a7.824,7.824,0,0,0,1.561-4.487,11.007,11.007,0,0,0-.715-4.1c-.326-.846-.585-1.431.325-1.886s.91-1.367.325-1.691a19.122,19.122,0,0,0-4.933-.78,19.122,19.122,0,0,0-4.933.78c-.585.325-.585,1.236.325,1.691s.651,1.04.326,1.886a10.97,10.97,0,0,0-.715,4.1,7.826,7.826,0,0,0,1.559,4.487c.455.389.888.822.3.976s-1.929.822-1.929,1.841,1.661,2.146,5.063,2.146,5.063-1.128,5.063-2.146S29.192,60.08,28.607,59.928Z",
    transform: "translate(2.725 7.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.261,41.571H24.272v6h10.46v24H40.8v-24h10.46Z",
    transform: "translate(4.436 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.73 57.965)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.405,53.017a1.775,1.775,0,0,0,2.255.735,1.776,1.776,0,0,0,3.531,0,1.775,1.775,0,0,0,1.764-3.057,1.775,1.775,0,0,0-1.764-3.057,1.776,1.776,0,0,0-3.531,0A1.775,1.775,0,0,0,35.9,50.695,1.775,1.775,0,0,0,35.405,53.017Zm3.2-3.747a1.645,1.645,0,1,1-.6,2.247A1.646,1.646,0,0,1,38.6,49.27Z",
    transform: "translate(-34.146 -46.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.7,55.771c0-1.026-1.3-3.988-5.28-3.814.542,5.459,4.173,5.571,5.28,5.571s4.738-.112,5.281-5.571C40.992,51.783,39.7,54.744,39.7,55.771Z",
    transform: "translate(-34.417 -43.922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonnaliseIcon);
export default __webpack_public_path__ + "static/media/personnalise-icon.9e6a6190d0d94e69afd72d85dcf8ecf1.svg";
export { ForwardRef as ReactComponent };